import { render } from "./header-topics.vue?vue&type=template&id=4f6cebcb&ts=true"
import script from "./header-topics.vue?vue&type=script&lang=ts"
export * from "./header-topics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__